module.exports = __webpack_public_path__ + "img/message-bubble.69429086.svg";